import Axios from "axios";
import {
  antdMessageError,
  errorHandler,
} from "../../helpers/Utils";
import { removeDuplicates } from "../../helpers/array";

export const getImumMonitorings =
  () => async (dispatch) => {
    try {
      dispatch({ type: "ONLY_LOADING_CUSTOM" });

      const { data } = await Axios.get(`/api/v1/${window.identifier}/imum_monitorings`);

      const categories = removeDuplicates(
        data.data.map(({ category }) => category).sort((a, b) => a.localeCompare(b))
      ).map((value) => ({
        value,
        label: value,
      }))
      dispatch({
        type: "GET_CUSTOMS",
        payload: {
          ...data,
          data: data.data,
          current: "imum_monitorings",
          totals: categories.length,
          show_data: {
            categories
          }
        },
      });
      return { success: true };
    } catch (err) {
      errorHandler(err);
      antdMessageError();
      return { success: false };
    }
  };
